import React from 'react'


function Products() {
  return (
    <div className='bg-[#0C2341] container min-h-screen mt-20'>
     Under Working
    </div>
  )
}

export default Products
